import axios from 'axios';
import Cookies from 'js-cookie';
import { urlConfig } from '../../config/urlConfig';
import jwt_decode from 'jwt-decode';

export const accessTokenRequest = () => {
  return axios.post(urlConfig.refresh_token_url, {
    refresh: Cookies.get('refresh_token'),
  });
};

export const sendRequest = (url, response, method, data) => {
  return axios({
    url,
    method,
    data: method !== 'get' ? data : null,
    headers: response
      ? {
          Authorization: `Bearer ${response.data.access}`,
        }
      : null,
  });
};

export const getUserData = (userIdentify, response) => {
  return sendRequest(
    urlConfig.get_user_data,
    response,
    'post',
    userIdentify
  );
};

export const checkIsLogin = (setStatus, setLoading) => {
  const refresh_token = Cookies.get('refresh_token');
  let decode = '';
  setLoading && setLoading(true);

  if (refresh_token) {
    decode = jwt_decode(refresh_token);
    if (Date.now() / 1000 > decode.exp) {
      setStatus(0);
      setLoading && setLoading(false);
      Cookies.remove('refresh_token', { path: '/' });
      Cookies.remove('access_token', { path: '/' });
      localStorage.clear();
    } else {
      // check account service is working?
      axios
        .post(urlConfig.refresh_token_url, {
          refresh: refresh_token,
        })
        .then((res) => {
          setStatus(1);
          setLoading && setLoading(false);
        })
        .catch((err) => {
          setStatus(0);
          setLoading && setLoading(false);
          Cookies.remove('refresh_token', { path: '/' });
          Cookies.remove('access_token', { path: '/' });
          localStorage.clear();
        });
    }
  } else {
    setStatus(0);
    setLoading && setLoading(false);
    Cookies.remove('refresh_token', { path: '/' });
    Cookies.remove('access_token', { path: '/' });
    localStorage.clear();
  }
};
